import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import axios from "../../axios";
import Alert from "react-s-alert";
import CustomModal from "../../components/CustomModal";
import moment from "moment";
import qs from "qs";
import Paging from "../../components/Paging";
import DatePicker from 'react-datepicker';
import {Badge} from "reactstrap";
import DropdownView from "./DropdownView";

class Lists extends Component {
    constructor() {
        super();
        this.state = {
            dataLibur       : [],
            dataParticipant : [],
            dataKategori    : [],
            arsip_file_id   : 0,
            pageCount       : 0,
            date            : moment(),
            currentPage     : 0,
            isLoading       : false,
            isModalShow     : false,
            isModalDelAllShow     : false,
            nama            :"",
            arsip_cat_id    :'',
            participant_id  :'',
            pageStart       :1,
            isAll           :false,
            isButtonLoading :false,
            selected        :[],
            arsip_id        :'',
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.toggleModalDelAll = this.toggleModalDelAll.bind(this);
        this.handleSubmitDeleteButton = this.handleSubmitDeleteButton.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeOptionTrue = this.handleChangeOptionTrue.bind(this);
        this.handleChangeOptionAll = this.handleChangeOptionAll.bind(this);
        this.handleHapusButton = this.handleHapusButton.bind(this);
    }

    handleHapusButton() {
        this.setState({ isButtonLoading: true });

        const url = '/arsip/deletesel'

        let newState = {
            locale:"id",
            platform:"web",
            user_id:localStorage.SISMART_USER_ID,
            arsip_id:Object.keys(this.selected)
        };

        axios({
            method: "post",
            url: url,
            data: qs.stringify(newState)
        })

            .then(response => {
                const result = response.data;

                if (result.success) {
                    Alert.success(result.message);
                    this.setState({ isButtonLoading: false, isAll:false },()=>{
                        this.selected=[];
                        this.loadData();
                        this.toggleModalDelAll();
                    });
                } else {
                    if (Array.isArray(result.message)) {
                        result.text.map(item => {
                            Alert.error(item);
                            return true;
                        });
                    } else {
                        Alert.error(result.message);
                    }

                    this.setState({ isButtonLoading: false });
                }
            })

            .catch(error => {
                console.log(error);
                this.setState({ isButtonLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });

        this.setState({ modalShow: false });
        // window.location.reload()
    }

    handleChangeOptionTrue(event, arsip_id) {

        this.selected = this.selected || {};
        if (event.target.checked) {
            this.selected[arsip_id] = true;
        } else {
            delete this.selected[arsip_id];
        }

    }

    handleChangeOptionAll(event) {

        this.selected = this.selected || {};
        if (event.target.checked) {
            this.setState({
                isAll: !this.state.isAll
            });
            this.state.dataLibur.map(item=>{
                this.selected[item.id] = true;
            })
        } else {
            this.setState({
                isAll: false
            });
            this.state.dataLibur.map(item=>{
                delete this.selected[item.id];
            })

        }


    }

    loadDataParti(){
        this.setState({ isLoading: true });
        const params = qs.stringify({
            locale:"id",
            platform:"web"
        });

        axios({
            method: "post",
            url: "/kelas?" + params
        })
            .then(response => {
                const result = response.data;

                if (result.success) {
                    const dataParticipant = result.data.map(item => ({
                        key: item.kelas_id,
                        value: item.kelas_nama
                    }));

                    this.setState({
                        dataParticipant,
                        isLoading: false
                    });
                } else {
                    Alert.error(result.text);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadDataKategori(){
        this.setState({ isLoading: true });
        const params = qs.stringify({
            locale:"id",
            platform:"web"
        });

        axios({
            method: "post",
            url: "/arsip/catlist?" + params
        })
            .then(response => {
                const result = response.data;

                if (result.success) {
                    const dataKategori = result.data.map(item => ({
                        key: item.arsip_cat_id,
                        value: item.arsip_cat_name
                    }));

                    this.setState({
                        dataKategori,
                        isLoading: false
                    });
                } else {
                    Alert.error(result.text);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    toggleModal() {
        this.setState({ isModalShow: !this.state.isModalShow });
    }

    toggleModalDelAll() {
        this.setState({ isModalDelAllShow: !this.state.isModalDelAllShow });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        const newState = {
            [name]: value
        }

        this.setState(
            newState,
            () => this.loadData()
        )
    }

    handleSubmitDeleteButton() {
        axios({
            method: 'get',
            url: '/arsip/delete/' + this.state.arsip_file_id
        })
            .then(response => {
                const result = response.data;

                Alert.success(result.message);
                this.loadData();
                this.toggleModal();

                return;
            })
            .catch(error => {

                this.setState({ isLoading: false })
                Alert.error("Gagal terhubung ke server!")
            })
    }

    handlePageClick(data) {
        let selected = data.selected; // zero based index

        this.setState({ currentPage: selected }, () => {
            this.loadData();
        });
    }

    loadData() {
        this.setState({ isLoading: true });

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            cari: this.state.nama,
            arsip_cat_id:this.state.arsip_cat_id,
            user_id:this.props.match.params.user_id,
            participant_id:this.state.participant_id
        });

        axios({
            method: "post",
            url: "/arsip/detail?" + params
        })
            .then(response => {
                const result = response.data;

                if (result.success === true) {
                    this.setState({
                        dataLibur: result.data.data,
                        pageCount: result.data.last_page,
                        pageStart: result.data.from,
                        isLoading: false
                    });
                } else {
                    Alert.error(result.message);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    componentDidMount() {
        this.loadData();
        this.loadDataParti();
        this.loadDataKategori();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.nama !== this.state.nama) {
            this.loadData()
        }
    }

    render() {
        return (
            <div className="col-sm-12">
                <CustomModal
                    isShow={this.state.isModalShow}
                    toggleModal={this.toggleModal}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Hapus Data"
                    modalBodyText="Anda yakin ingin menghapus data ini?"
                    modalSubmitText="Ya"
                />
                <CustomModal
                    isShow={this.state.isModalDelAllShow}
                    toggleModal={this.toggleModalDelAll}
                    handleSubmit={this.handleHapusButton}
                    modalHeaderText="Hapus Data"
                    modalBodyText="Anda yakin ingin menghapus data ini?, semua data yg dipilih akan dihapus secara permanen"
                    modalSubmitText="Ya"
                />
                <div className="card">
                    <div className="card-block">
                        <NavLink
                            to={`${this.props.match.url}/add`}
                            className="btn btn-primary"
                        >
                            Upload Document
                        </NavLink>
                    </div>
                </div>
                <div className="card" >
                    <div className="card-block">
                        <div className="col-md-12 form-group row">
                            <div className="col-md-12">
                                <DropdownView
                                    handleChange={this.handleChange}
                                    stateName="arsip_cat_id"
                                    label="Pilih Kategori"
                                    disabled={this.props.mode === 'Edit' ? true : false}
                                    items={this.state.dataKategori}
                                    value={this.state.arsip_cat_id}
                                />
                            </div>
                            {/*<div className="col-md-12">*/}
                            {/*    <DropdownView*/}
                            {/*        handleChange={this.handleChange}*/}
                            {/*        stateName="participant_id"*/}
                            {/*        label="Pilih Kelas Peserta"*/}
                            {/*        disabled={this.props.mode === 'Edit' ? true : false}*/}
                            {/*        items={this.state.dataParticipant}*/}
                            {/*        value={this.state.participant_id}*/}
                            {/*    />*/}
                            {/*</div>*/}
                            <div className="col-md-12">
                                <input
                                    name="nama"
                                    type="text"
                                    className="form-control"
                                    placeholder="Ketikkan Nama Pengguna..."
                                    value={this.state.nama}
                                    onChange={this.handleChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-header">
                        E-Document
                    </div>
                    <div className="card-block">
                        {this.state.isLoading ? (
                            "Memuat Data..."
                        ) : this.state.dataLibur.length === 0 ? (
                            "Data Kosong..."
                        ) : (
                            <div>
                                <div className="col-md-12" style={{ marginBottom:'45px' }}>
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-sm float-right pull-right"
                                        onClick={() => {
                                            this.toggleModalDelAll();
                                        }} >
                                        Hapus
                                    </button>
                                </div>
                                <table className="table table-striped table-bordered animated fadeIn">
                                    <thead>
                                    <tr>
                                        <th width={10}>No.</th>
                                        <th width={10}>
                                            <input
                                                type="checkbox"
                                                value={this.state.isAll}
                                                onChange={e => this.handleChangeOptionAll(e)}
                                            />
                                        </th>
                                        <th>Nama Siswa</th>
                                        <th>Nama File</th>
                                        <th>Type</th>
                                        <th width={200}>Aksi</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.dataLibur.map((item,i) => {
                                        return (
                                            <tr key={item.id}>
                                                <td>
                                                    {i+this.state.pageStart}
                                                </td>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        value={item.id}
                                                        disabled={this.state.isAll}
                                                        onChange={e => this.handleChangeOptionTrue(e, item.id)}
                                                    />
                                                </td>
                                                <td>{item.user_nama}</td>
                                                <td>{item.file_name}</td>
                                                <td><Badge color={'danger'}>{item.arsip_cat_name}</Badge></td>
                                                <td>
                                                    <a
                                                        type="button"
                                                        className="btn btn-primary btn-sm"
                                                        href={item.file_url}
                                                        target="_blank"
                                                    >
                                                        Download
                                                    </a>{" "}
                                                    {/*<button*/}
                                                    {/*    type="button"*/}
                                                    {/*    className="btn btn-danger btn-sm"*/}
                                                    {/*    onClick={() => {*/}
                                                    {/*        this.toggleModal();*/}
                                                    {/*        this.setState({ arsip_file_id: item.id });*/}
                                                    {/*    }}*/}
                                                    {/*>*/}
                                                    {/*    Hapus*/}
                                                    {/*</button>*/}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>

                                <Paging
                                    handlePageClick={this.handlePageClick.bind(this)}
                                    pageCount={this.state.pageCount}
                                    currentPage={this.state.currentPage}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/Arsip/Details.js